import { useQuery } from '@tanstack/react-query';
import type { Caisse } from '@sirajoptic/shared';
import { api } from '@/lib/api-client';

export const clesCaisse = {
  tous: ['caisse'] as const,
  jour: (date: string) => ['caisse', date] as const,
};

/**
 * Clôture d'une journée.
 *
 * `staleTime` court volontairement : on ouvre cet écran en fin de journée, au
 * moment précis où une dernière vente peut encore tomber. Mieux vaut relire que
 * compter le tiroir face à un total périmé.
 */
export function useCaisse(date: string) {
  return useQuery({
    queryKey: clesCaisse.jour(date),
    queryFn: () => api.get<Caisse>('/caisse', { date }),
    staleTime: 5_000,
    placeholderData: (precedent) => precedent,
  });
}
